import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  getPlayerFallbackPath,
  isFeatureEnabled,
  type FeatureKey,
} from '@config/releaseProfile';

interface FeatureRouteProps {
  feature: FeatureKey;
  children: React.ReactNode;
  /** Override redirect when feature is off (default: player contests home) */
  redirectTo?: string;
}

/**
 * Soft-gates a route without deleting the underlying page module.
 * When the feature is disabled for the current release profile, redirects away.
 */
const FeatureRoute: React.FC<FeatureRouteProps> = ({ feature, children, redirectTo }) => {
  if (!isFeatureEnabled(feature)) {
    return <Navigate to={redirectTo || getPlayerFallbackPath()} replace />;
  }
  return <>{children}</>;
};

export default FeatureRoute;
